import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { trackPriceQuoteRequest } from '../../util/mixpanel';

// Import Style
import './SubscribeEDAddOn.scss';

class SubscribeEDAddOn extends Component {
  static defaultProps = {
    user: {}
  };

  constructor() {
    super();
  }

  trackPriceRequestClick() {
    trackPriceQuoteRequest();
  }

  render() {
    const remainingTrial = moment(this.props.user.config.exportTrialEnd).diff(moment(), 'days') + 1;
    const trialExpired = moment(this.props.user.config.exportTrialEnd).diff(moment()) < 0;
    if ((this.props.user.config.exportActivationDate || !this.props.user.config.exportTrialEnd)
      && this.props.user.config.exportEnabled) return '';
    let status;
    let tone = '';
    if (trialExpired) {
      status = 'Trial ended';
      tone = 'ended';
    } else if (this.props.user.config.exportDeactivationDate && !this.props.user.config.exportEnabled) {
      status = 'Subscription ended';
      tone = 'ended';
    } else {
      status = `Trial · ${remainingTrial} ${remainingTrial != 1 ? 'days' : 'day'} left`;
      tone = remainingTrial <= 1 ? 'ended' : remainingTrial <= 3 ? 'soon' : '';
    }
    return (
      <div className={`subscribe_box trial_status ${tone}`}>
        <span>{status}</span>
        {this.props.user.permissions && this.props.user.permissions.manageBilling && (
          <a
            href="mailto:hello@getnave.com"
            className='trial_status_action'
            onClick={this.trackPriceRequestClick}
            onAuxClick={this.trackPriceRequestClick}
          >
            Request a quote →
          </a>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

export default connect(mapStateToProps)(SubscribeEDAddOn);
